export const lights = [
  // {
  //   id: 0,
  //   groups: [{
  //     id: 'left',
  //     index: 0
  //   }, 
  //   {
  //     id: 'everything',
  //     index: 0
  //   },
  // ]
  // },
  {
  id: 1,
  groups: [{
    id: 'left',
    index: 1
  }, 
  {
    id: 'everything',
    index: 1
  },
  {
    id: 'outer',
    index: 0
  },
  {
    id: 'outersides',
    index: 0
  },
  ]
},
{
  id: 2,
  groups: [{
    id: 'left',
    index: 2
  },
  {
    id: 'everything',
    index: 2
  },
  {
    id: 'outer',
    index: 1
  },
  {
    id: 'outersides',
    index: 1
  },
]
},
{
  id: 3,
  groups: [{
    id: 'left',
    index: 3
  }, 
  {
    id: 'everything',
    index: 3
  },
  {
    id: 'outer',
    index: 2
  },
  {
    id: 'outersides',
    index: 2
  },
]
},
{
  id: 4,
  groups: [{
    id: 'left',
    index: 4
  }, 
  {
    id: 'everything',
    index: 4
  },
  {
    id: 'outer',
    index: 3
  },
  {
    id: 'outersides',
    index: 3
  },
]
},
{
  id: 5,
  groups: [{
    id: 'right',
    index: 1
  }, 
  {
    id: 'everything',
    index: 5
  },
  {
    id: 'outer',
    index: 4
  },
  {
    id: 'outersides',
    index: 4
  },
]
},
{
  id: 6,
  groups: [{
    id: 'right',
    index: 2
  }, 
  {
    id: 'everything',
    index: 6
  },
  {
    id: 'outer',
    index: 5
  },
  {
    id: 'outerSides',
    index: 5
  },
]
},
{
  id: 7,
  groups: [{
    id: 'right',
    index: 3
  }, 
  {
    id: 'everything',
    index: 7
  },
  {
    id: 'outer',
    index: 6
  },
  {
    id: 'outersides',
    index: 6
  },
]
},
{
  id: 8,
  groups: [{
    id: 'right',
    index: 4
  }, 
  {
    id: 'everything',
    index: 8
  },
  {
    id: 'outer',
    index: 7
  },
  {
    id: 'outersides',
    index: 7
  },
]
},
// {
//   id: 9,
//   groups: [{
//     id: 'right',
//     index: 5
//   }, 
//   {
//     id: 'everything',
//     index: 9
//   },
// ]
// },
{
  id: 19,
  groups: [{
    id: 'left',
    index: 0
  }, 
  {
    id: 'everything',
    index: 10
  },
  {
    id: 'outer',
    index: 8
  },
  {
    id: 'outersides',
    index: 0
  },
] 
},
{
  id: 29,
  groups: [{
    id: 'left',
    index: 1
  }, 
  {
    id: 'everything',
    index: 11
  },
  {
    id: 'outer',
    index: 9
  },
  {
    id: 'outersides',
    index: 1
  },
] 
},
{
  id: 39,
  groups: [{
    id: 'left',
    index: 2
  }, 
  {
    id: 'everything',
    index: 12
  },
  {
    id: 'outer',
    index: 10
  },
  {
    id: 'outersides',
    index: 2
  },
] 
},
{
  id: 49,
  groups: [{
    id: 'left',
    index: 3
  }, 
  {
    id: 'everything',
    index: 13
  },
  {
    id: 'outer',
    index: 11
  },
  {
    id: 'outersides',
    index: 3
  },
] 
},
{
  id: 59,
  groups: [{
    id: 'right',
    index: 0
  }, 
  {
    id: 'everything',
    index: 14
  },
  {
    id: 'outer',
    index: 12
  },
  {
    id: 'outersides',
    index: 4
  },
] 
},
{
  id: 69,
  groups: [{
    id: 'right',
    index: 1
  }, 
  {
    id: 'everything',
    index: 15
  },
  {
    id: 'outer',
    index: 13
  },
  {
    id: 'outersides',
    index: 5
  },
] 
},
{
  id: 79,
  groups: [{
    id: 'right',
    index: 2
  }, 
  {
    id: 'everything',
    index: 16
  },
  {
    id: 'outer',
    index: 14
  },
  {
    id: 'outersides',
    index: 6
  },
] 
},
{
  id: 89,
  groups: [{
    id: 'right',
    index: 3
  }, 
  {
    id: 'everything',
    index: 17
  },
  {
    id: 'outer',
    index: 15
  },
  {
    id: 'outersides',
    index: 7
  },
] 
},
// {
//   id: 99,
//   groups: [{
//     id: 'right',
//     index: 4
//   }, 
//   {
//     id: 'everything',
//     index: 18
//   },
// ] 
// },
{
  id: 98,
  groups: [{
    id: 'left',
    index: 0
  }, 
  {
    id: 'everything',
    index: 19
  },
  {
    id: 'outer',
    index: 16
  },
  {
    id: 'outersides',
    index: 0
  },
] 
},
{
  id: 97,
  groups: [{
    id: 'left',
    index: 1
  }, 
  {
    id: 'everything',
    index: 20
  },
  {
    id: 'outer',
    index: 17
  },
  {
    id: 'outersides',
    index: 1
  },
] 
},
{
  id: 96,
  groups: [{
    id: 'left',
    index: 2
  }, 
  {
    id: 'everything',
    index: 21
  },
  {
    id: 'outer',
    index: 18
  },
  {
    id: 'outersides',
    index: 2
  },
] 
},
{
  id: 95,
  groups: [{
    id: 'left',
    index: 3
  }, 
  {
    id: 'everything',
    index: 22
  },
  {
    id: 'outer',
    index: 19
  },
  {
    id: 'outersides',
    index: 3
  },
] 
},
{
  id: 94,
  groups: [{
    id: 'right',
    index: 0
  }, 
  {
    id: 'everything',
    index: 23
  },
  {
    id: 'outer',
    index: 20
  },
  {
    id: 'outersides',
    index: 4
  },
] 
},
{
  id: 93,
  groups: [{
    id: 'right',
    index: 1
  }, 
  {
    id: 'everything',
    index: 24
  },
  {
    id: 'outer',
    index: 21
  },
  {
    id: 'outersides',
    index: 5
  },
] 
},
{
  id: 92,
  groups: [{
    id: 'right',
    index: 2
  }, 
  {
    id: 'everything',
    index: 25
  },
  {
    id: 'outer',
    index: 22
  },
  {
    id: 'outersides',
    index: 6
  },
] 
},
{
  id: 91,
  groups: [{
    id: 'right',
    index: 3
  }, 
  {
    id: 'everything',
    index: 26
  },
  {
    id: 'outer',
    index: 23
  },
  {
    id: 'outersides',
    index: 7
  },
] 
},
// {
//   id: 90,
//   groups: [{
//     id: 'left',
//     index: 11
//   }, 
//   {
//     id: 'everything',
//     index: 27
//   },
// ] 
// },
{
  id: 80,
  groups: [{
    id: 'left',
    index: 0
  }, 
  {
    id: 'everything',
    index: 28
  },
  {
    id: 'outer',
    index: 24
  },
  {
    id: 'outersides',
    index: 0
  },
] 
},
{
  id: 70,
  groups: [{
    id: 'left',
    index: 1
  }, 
  {
    id: 'everything',
    index: 29
  },
  {
    id: 'outer',
    index: 25
  },
  {
    id: 'outersides',
    index: 1
  },
] 
},
{
  id: 60,
  groups: [{
    id: 'left',
    index: 2
  }, 
  {
    id: 'everything',
    index: 30
  },
  {
    id: 'outer',
    index: 26
  },
  {
    id: 'outersides',
    index: 2
  },
] 
},
{
  id: 50,
  groups: [{
    id: 'left',
    index: 3
  }, 
  {
    id: 'everything',
    index: 31
  },
  {
    id: 'outer',
    index: 27
  },
  {
    id: 'outersides',
    index: 3
  },
] 
},
{
  id: 40,
  groups: [{
    id: 'right',
    index: 0
  }, 
  {
    id: 'everything',
    index: 32
  },
  {
    id: 'outer',
    index: 28
  },
  {
    id: 'outersides',
    index: 4
  },
] 
},
{
  id: 30,
  groups: [{
    id: 'right',
    index: 1
  }, 
  {
    id: 'everything',
    index: 33
  },
  {
    id: 'outer',
    index: 29
  },
  {
    id: 'outersides',
    index: 5
  },
] 
},
{
  id: 20,
  groups: [{
    id: 'right',
    index: 2
  }, 
  {
    id: 'everything',
    index: 34
  },
  {
    id: 'outer',
    index: 30
  },
  {
    id: 'outersides',
    index: 6
  },
] 
},
{
  id: 10,
  groups: [{
    id: 'right',
    index: 3
  }, 
  {
    id: 'everything',
    index: 35
  },
  {
    id: 'outer',
    index: 31
  },
  {
    id: 'outersides',
    index: 7
  },
] 
},

{
  id: 33,
  groups: [{
    id: 'square',
    index: 1
  }, 
  {
    id: 'everything',
    index: 36
  },
] 
},

{
  id: 34,
  groups: [{
    id: 'square',
    index: 2
  }, 
  {
    id: 'everything',
    index: 37
  },
] 
},
{
  id: 35,
  groups: [{
    id: 'square',
    index: 3
  }, 
  {
    id: 'everything',
    index: 38
  },
] 
},

{
  id: 36,
  groups: [{
    id: 'square',
    index: 4
  }, 
  {
    id: 'everything',
    index: 39
  },
] 
},
{
  id: 43,
  groups: [{
    id: 'square',
    index: 5
  }, 
  {
    id: 'everything',
    index: 40
  },
] 
},
{
  id: 44,
  groups: [{
    id: 'square',
    index: 6
  }, 
  {
    id: 'everything',
    index: 41
  },
] 
},
{
  id: 45,
  groups: [{
    id: 'square',
    index: 7
  }, 
  {
    id: 'everything',
    index: 42
  },
] 
},
{
  id: 46,
  groups: [{
    id: 'square',
    index: 8
  }, 
  {
    id: 'everything',
    index: 43
  },
] 
},
{
  id: 53,
  groups: [{
    id: 'square',
    index: 9
  }, 
  {
    id: 'everything',
    index: 44
  },
] 
},
{
  id: 54,
  groups: [{
    id: 'square',
    index: 10
  }, 
  {
    id: 'everything',
    index: 45
  },
] 
},
{
  id: 55,
  groups: [{
    id: 'square',
    index: 11
  }, 
  {
    id: 'everything',
    index: 46
  },
] 
},
{
  id: 56,
  groups: [{
    id: 'square',
    index: 12
  }, 
  {
    id: 'everything',
    index: 47
  },
] 
},
{
  id: 63,
  groups: [{
    id: 'square',
    index: 13
  }, 
  {
    id: 'everything',
    index: 48
  },
] 
},
{
  id: 64,
  groups: [{
    id: 'square',
    index: 14
  }, 
  {
    id: 'everything',
    index: 49
  },
] 
},
{
  id: 65,
  groups: [{
    id: 'square',
    index: 15
  }, 
  {
    id: 'everything',
    index: 50
  },
] 
},
{
  id: 66,
  groups: [{
    id: 'square',
    index: 16
  }, 
  {
    id: 'everything',
    index: 51
  },
] 
},



// {
//   id: 12,
//   groups: [{
//     id: 'ethouse',
//     index: 0
//   }, 
//   {
//     id: 'wn',
//     index: 0
//   }, 
//   {
//     id: 'square',
//     index: 12
//   },
//   {
//     id: 'west',
//     index: 4
//   },]
// },
// {
//   id: 13,
//   groups: [{
//     id: 'ethouse',
//     index: 1
//   }, 
//   {
//     id: 'wn',
//     index: 1
//   }, 
//   {
//     id: 'square',
//     index: 13
//   },
//   {
//     id: 'west',
//     index: 5
//   },]
// },
// {
//   id: 14,
//   groups: [{
//     id: 'ethouse',
//     index: 2
//   }, 
//   {
//     id: 'wn',
//     index: 2
//   }, 
//   {
//     id: 'square',
//     index: 14
//   },
//   {
//     id: 'west',
//     index: 6
//   },]
// },
// {
//   id: 15,
//   groups: [{
//     id: 'ethouse',
//     index: 3
//   }, 
//   {
//     id: 'wn',
//     index: 3
//   }, 
//   {
//     id: 'square',
//     index: 15
//   },
//   {
//     id: 'west',
//     index: 7
//   },]
// },
// {
//   id: 16,
//   groups: [{
//     id: 'cafe',
//     index: 0
//   }, 
//   {
//     id: 'nw',
//     index: 0
//   }, 
//   {
//     id: 'square',
//     index: 16
//   },
//   {
//     id: 'north',
//     index: 0
//   },]
// },
// {
//   id: 17,
//   groups: [{
//     id: 'cafe',
//     index: 1
//   }, 
//   {
//     id: 'nw',
//     index: 1
//   }, 
//   {
//     id: 'square',
//     index: 17
//   },
//   {
//     id: 'north',
//     index: 1
//   },]
// },
// {
//   id: 18,
//   groups: [{
//     id: 'inklink',
//     index: 0
//   }, 
//   {
//     id: 'nw',
//     index: 2
//   }, 
//   {
//     id: 'square',
//     index: 18
//   },
//   {
//     id: 'north',
//     index: 2
//   },]
// },
// {
//   id: 19,
//   groups: [{
//     id: 'inklink',
//     index: 1
//   }, 
//   {
//     id: 'nw',
//     index: 3
//   }, 
//   {
//     id: 'square',
//     index: 19
//   },
//   {
//     id: 'north',
//     index: 3
//   },]
// },
// {
//   id: 20,
//   groups: [{
//     id: 'globalglass',
//     index: 0
//   }, 
//   {
//     id: 'ne',
//     index: 0
//   }, 
//   {
//     id: 'square',
//     index: 20
//   },
//   {
//     id: 'north',
//     index: 4
//   },]
// },
// {
//   id: 21,
//   groups: [{
//     id: 'globalglass',
//     index: 1
//   }, 
//   {
//     id: 'ne',
//     index: 1
//   }, 
//   {
//     id: 'square',
//     index: 21
//   },
//   {
//     id: 'north',
//     index: 5
//   },]
// },
// {
//   id: 22,
//   groups: [{
//     id: 'als',
//     index: 0
//   }, 
//   {
//     id: 'ne',
//     index: 2
//   }, 
//   {
//     id: 'square',
//     index: 22
//   },
//   {
//     id: 'north',
//     index: 6
//   },]
// },
// {
//   id: 23,
//   groups: [{
//     id: 'als',
//     index: 1
//   }, 
//   {
//     id: 'ne',
//     index: 3
//   }, 
//   {
//     id: 'square',
//     index: 23
//   },
//   {
//     id: 'north',
//     index: 7
//   },]
// },
// {
//   id: 24,
//   groups: [{
//     id: 'cobble',
//     index: 0
//   }, 
//   {
//     id: 'en',
//     index: 0
//   }, 
//   {
//     id: 'square',
//     index: 24
//   },
//   {
//     id: 'east',
//     index: 0
//   },]
// },
// {
//   id: 25,
//   groups: [{
//     id: 'cobble',
//     index: 1
//   }, 
//   {
//     id: 'en',
//     index: 1
//   }, 
//   {
//     id: 'square',
//     index: 25
//   },
//   {
//     id: 'east',
//     index: 1
//   },]
// },
// {
//   id: 26,
//   groups: [{
//     id: 'ecp',
//     index: 0
//   }, 
//   {
//     id: 'en',
//     index: 2
//   }, 
//   {
//     id: 'square',
//     index: 26
//   },
//   {
//     id: 'east',
//     index: 2
//   },]
// },
// {
//   id: 27,
//   groups: [{
//     id: 'ecp',
//     index: 1
//   }, 
//   {
//     id: 'en',
//     index: 3
//   }, 
//   {
//     id: 'square',
//     index: 27
//   },
//   {
//     id: 'east',
//     index: 3
//   },]
// },
// {
//   id: 28,
//   groups: [{
//     id: 'xxx',
//     index: 0
//   }, 
//   {
//     id: 'es',
//     index: 0
//   }, 
//   {
//     id: 'square',
//     index: 28
//   },
//   {
//     id: 'east',
//     index: 4
//   },]
// },
// {
//   id: 29,
//   groups: [{
//     id: 'xxx',
//     index: 1
//   }, 
//   {
//     id: 'es',
//     index: 1
//   }, 
//   {
//     id: 'square',
//     index: 29
//   },
//   {
//     id: 'east',
//     index: 5
//   },]
// },
// {
//   id: 30,
//   groups: [{
//     id: 'historic',
//     index: 0
//   }, 
//   {
//     id: 'es',
//     index: 2
//   }, 
//   {
//     id: 'square',
//     index: 30
//   },
//   {
//     id: 'east',
//     index: 6
//   },]
// },
// {
//   id: 31,
//   groups: [{
//     id: 'historic',
//     index: 1
//   }, 
//   {
//     id: 'es',
//     index: 3
//   }, 
//   {
//     id: 'square',
//     index: 31
//   },
//   {
//     id: 'east',
//     index: 7
//   },]
//},
].map(light => ({...light, states: [], on: ()  => false}))